module.exports = __webpack_public_path__ + "static/media/tree-sphere.ab8b1339.svg";